import React from 'react';
import i18next from 'i18next';
import {toast} from 'react-toastify';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Loading from '../../Custom UI/Loading/Loading';
import LoadFailed from '../../Custom UI/LoadFailed/LoadFailed';
import BlueButton from '../../Custom UI/Buttons/BlueButton/BlueButton';
import GrayButton from '../../Custom UI/Buttons/GrayButton/GrayButton';
import LabeledTextInput from '../../Custom UI/LabeledInputs/LabeledTextInput/LabeledTextInput';
import LabeledPhoneNumberInput from '../../Custom UI/LabeledInputs/LabeledPhoneNumberInput/LabeledPhoneNumberInput';
import LabeledDropDown from '../../Custom UI/LabeledInputs/LabeledDropDown/LabeledDropDown';
import {languageOptions} from '../../Helpers/Helpers';
import {NOTIFY_OPTS} from '../../constants/Notifiers';
import '../HealthCareProviderInformationList/HealthCareProviderInformationList.scss';

const blankCaregiver = () => ({preferred_language:'en', selected_for_scheduling:false});

class CaregiverInformationCell extends React.Component {
  constructor(props){
    super(props);
    this.state = {form:{...blankCaregiver(), ...props.caregiver}, saving:false};
  }

  setValue = (key, value) => this.setState({form:{...this.state.form, [key]:value}});

  save = () => {
    const {form} = this.state;
    if(!form.first_name || !form.last_name || !form.email){
      toast(i18next.t('CAREGIVER_REQUIRED_FIELDS'), NOTIFY_OPTS.autoCloseFiveSeconds);
      return;
    }
    this.setState({saving:true});
    this.props.save(form).then(() => {
      toast(i18next.t('CAREGIVER_SAVE_SUCCESS'), NOTIFY_OPTS.autoCloseFiveSeconds);
      this.setState({saving:false});
    }, () => {
      toast(i18next.t('CAREGIVER_SAVE_FAILURE'), NOTIFY_OPTS.autoCloseFiveSeconds);
      this.setState({saving:false});
    });
  };

  render(){
    const {form, saving} = this.state;
    const input = (label, key, required = false) => (
      <LabeledTextInput className="health-care-provider-information-input" label={i18next.t(label)}
                        value={form[key]} required={required}
                        handleSave={event => this.setValue(key, event.target.value)}/>
    );
    return <div className="alternative-contact-section alternative-contact-cell-labeled-phone-number-input">
      {input('FIRST_NAME_PROPER_CAPITALIZED', 'first_name', true)}
      {input('LAST_NAME_PROPER_CAPITALIZED', 'last_name', true)}
      {input('EMAIL', 'email', true)}
      {input('RELATIONSHIP_TO_PATIENT', 'relationship_to_patient')}
      <LabeledPhoneNumberInput className="health-care-provider-information-input" label={i18next.t('PHONE_NUMBER')}
                               value={form.primary_phone_number} countryCode={this.props.patient.country_code || 'US'}
                               handleSave={value => this.setValue('primary_phone_number', value)}/>
      <LabeledPhoneNumberInput className="health-care-provider-information-input" label={i18next.t('ALTERNATIVE_PHONE_NUMBER')}
                               value={form.alternative_phone_number} countryCode={this.props.patient.country_code || 'US'}
                               handleSave={value => this.setValue('alternative_phone_number', value)}/>
      <LabeledDropDown className="health-care-provider-information-input" label={i18next.t('PREFERRED_LANGUAGE')}
                       value={languageOptions.filter(option => option.value === form.preferred_language)} options={languageOptions}
                       handleSave={option => this.setValue('preferred_language', option.value)}/>
      <label className="health-care-provider-information-input">
        <input type="checkbox" checked={Boolean(form.selected_for_scheduling)}
               onChange={event => this.setValue('selected_for_scheduling', event.target.checked)}/>
        {' ' + i18next.t('USE_FOR_SCHEDULED_SURVEY_LINKS')}
      </label>
      <GrayButton className="button-margin" name={i18next.t('REMOVE')} onClick={this.props.remove}/>
      <BlueButton className="button-popover" name={i18next.t('SAVE_PROPER_CAPITALIZED')} onClick={this.save} disabled={saving}/>
    </div>;
  }
}

export default class CaregiverInformationList extends React.Component {
  state = {caregivers:this.props.patient.caregiver_informations || [], loading:false, loadFailed:false};

  componentDidMount(){ this.load(); }

  componentDidUpdate(prevProps){
    if(prevProps.patient.caregiver_informations !== this.props.patient.caregiver_informations){
      this.setState({caregivers:this.props.patient.caregiver_informations || []});
    }
  }

  load = () => {
    this.setState({loading:true});
    this.props.load(this.props.patient.id).then(() => this.setState({loading:false, loadFailed:false}),
      () => this.setState({loading:false, loadFailed:true}));
  };

  render(){
    const {caregivers, loading, loadFailed} = this.state;
    return <div className="groups-outer-container">
      <div className="patient-profile-title-alt">{i18next.t('CAREGIVER_INFORMATION')}
        <AddCircleOutlineIcon style={{height:'20px', width:'20px', color:'#2D81C9'}}
                              onClick={() => this.setState({caregivers:[...caregivers, blankCaregiver()]})}/>
      </div>
      <div className="profile-alternative-contact-list">
        {loading ? <Loading/> : loadFailed ? <LoadFailed retry={this.load}/> : caregivers.length === 0 ?
          <div className="health-care-provider-list-no-health-care-providers-found">{i18next.t('NO_CAREGIVERS')}</div> :
          caregivers.map((caregiver, index) => <div className="healthcare-provider-information-section-container"
            key={'caregiver-' + (caregiver.id || index) + '-' + caregiver.selected_for_scheduling}>
            <div className="healthcare-provider-information-section-title">{i18next.t('CAREGIVER') + ' - ' + (index + 1)}</div>
            <CaregiverInformationCell caregiver={caregiver} patient={this.props.patient}
              save={form => this.props.save(form, this.props.patient.id)}
              remove={() => caregiver.id ? this.props.remove(caregiver, this.props.patient.id) :
                this.setState({caregivers:caregivers.filter((_, itemIndex) => itemIndex !== index)})}/>
          </div>)}
      </div>
    </div>;
  }
}
